import React, { useState } from 'react'
import Container from '../../layouts/Container/Container'
import Button from '../atoms/Button'
import { sendDataLayer } from '../../utils/functions'

import {
  stQuiz
} from './../../utils/helpers'
import { connect } from 'react-redux'
// import { sendDataLayer } from '../../utils/functions'

function TestQuestions({
  token
}) {
  const [yesOrNot, setYesOrNot] = useState(false)
  const [response, setResponse] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [ok, serOk] = useState(false)
  const [hoveredOption, setHoveredOption] = useState(null);

  const respond = (str) => {
    setYesOrNot(str)
  }
  const handleQuiz = () => {
    sendDataLayer({datalayer: { event: 'survey', text_title: '¿La información de los premios fue clara?', message: yesOrNot},repeat: true})
    
    if (!ok) {
      setIsLoading(true)
  
      stQuiz(token, yesOrNot, response).then((res) => {
  
        if (res && res.statusCode === 200) {
          setYesOrNot(false)
          setResponse("")
          serOk(true)
        }
        setIsLoading(false)
      }).catch(() => {
        setIsLoading(false)
      })
    }

  }
  const handleChange = async (e) => {
    if (e.target.value.length <= 500) setResponse(e.target.value)
  }

  return (
    <div className={`mc-test-questions`}>
      <Container>
        {!ok &&
          <h4>
          ¿La información de los premios fue clara?
          </h4>
        }
        
        {!ok &&
          <div className='mc-test-questions--buttons'>
            <button className={`button-quiz ${yesOrNot === 'Si' ? 'active': ''}`} onClick={() =>respond('Si')} onMouseEnter={() => setHoveredOption('Si')} onMouseLeave={() => setHoveredOption(null)}>
              {(yesOrNot === 'Si' || hoveredOption === 'Si')
              ? <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <g clipPath="url(#clip0_4810_8799)">
                  <path d="M4.66683 14.6666H2.66683C2.31321 14.6666 1.97407 14.5261 1.72402 14.2761C1.47397 14.026 1.3335 13.6869 1.3335 13.3333V8.66659C1.3335 8.31296 1.47397 7.97383 1.72402 7.72378C1.97407 7.47373 2.31321 7.33325 2.66683 7.33325H4.66683M9.3335 5.99992V3.33325C9.3335 2.80282 9.12278 2.29411 8.74771 1.91904C8.37264 1.54397 7.86393 1.33325 7.3335 1.33325L4.66683 7.33325V14.6666H12.1868C12.5084 14.6702 12.8204 14.5575 13.0654 14.3493C13.3105 14.141 13.4719 13.8512 13.5202 13.5333L14.4402 7.53325C14.4692 7.34216 14.4563 7.14704 14.4024 6.96142C14.3485 6.7758 14.2549 6.60412 14.1281 6.45826C14.0012 6.31241 13.8442 6.19587 13.6679 6.11673C13.4915 6.03759 13.3001 5.99773 13.1068 5.99992H9.3335Z" stroke="#FFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_4810_8799">
                  <rect width="16" height="16" fill="white"/>
                  </clipPath>
                  </defs>
                </svg>
              : <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <g clipPath="url(#clip0_9405_1499)">
                    <path d="M4.66634 14.6666H2.66634C2.31272 14.6666 1.97358 14.5261 1.72353 14.2761C1.47348 14.026 1.33301 13.6869 1.33301 13.3333V8.66659C1.33301 8.31296 1.47348 7.97383 1.72353 7.72378C1.97358 7.47373 2.31272 7.33325 2.66634 7.33325H4.66634M9.33301 5.99992V3.33325C9.33301 2.80282 9.12229 2.29411 8.74722 1.91904C8.37215 1.54397 7.86344 1.33325 7.33301 1.33325L4.66634 7.33325V14.6666H12.1863C12.5079 14.6702 12.8199 14.5575 13.0649 14.3493C13.31 14.141 13.4715 13.8512 13.5197 13.5333L14.4397 7.53325C14.4687 7.34216 14.4558 7.14704 14.4019 6.96142C14.348 6.7758 14.2544 6.60412 14.1276 6.45826C14.0008 6.31241 13.8437 6.19587 13.6674 6.11673C13.4911 6.03759 13.2996 5.99773 13.1063 5.99992H9.33301Z" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_9405_1499">
                      <rect width="16" height="16" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
              }
              
              &nbsp;&nbsp;&nbsp;&nbsp;Sí
            </button>
            <button className={`button-quiz ${yesOrNot === 'No' ? 'active': ''}`} onClick={() =>respond('No')} onMouseEnter={() => setHoveredOption('No')} onMouseLeave={() => setHoveredOption(null)}>
              {(yesOrNot === 'No' || hoveredOption === 'No')
                ? <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                    <g clipPath="url(#clip0_4810_8804)">
                    <path d="M11.8334 1.33325H13.6134C13.9907 1.32658 14.3573 1.45867 14.6436 1.70446C14.93 1.95025 15.1161 2.29262 15.1667 2.66658V7.33325C15.1161 7.70721 14.93 8.04958 14.6436 8.29537C14.3573 8.54116 13.9907 8.67325 13.6134 8.66658H11.8334M7.16669 9.99991V12.6666C7.16669 13.197 7.3774 13.7057 7.75247 14.0808C8.12755 14.4559 8.63625 14.6666 9.16669 14.6666L11.8334 8.66658V1.33325H4.31335C3.9918 1.32961 3.67977 1.44231 3.43475 1.65058C3.18973 1.85884 3.02824 2.14864 2.98002 2.46658L2.06002 8.46658C2.03102 8.65768 2.0439 8.85279 2.09779 9.03841C2.15168 9.22403 2.24529 9.39572 2.37211 9.54157C2.49894 9.68743 2.65597 9.80396 2.83231 9.8831C3.00864 9.96225 3.20008 10.0021 3.39335 9.99991H7.16669Z" stroke="#FFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_4810_8804">
                    <rect width="16" height="16" fill="white" transform="translate(0.5)"/>
                    </clipPath>
                    </defs>
                  </svg>
                : <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <g clipPath="url(#clip0_9405_1804)">
                      <path d="M11.3334 1.33325H13.1134C13.4907 1.32658 13.8573 1.45867 14.1436 1.70446C14.43 1.95025 14.6161 2.29262 14.6667 2.66658V7.33325C14.6161 7.70721 14.43 8.04958 14.1436 8.29537C13.8573 8.54116 13.4907 8.67325 13.1134 8.66658H11.3334M6.66669 9.99991V12.6666C6.66669 13.197 6.8774 13.7057 7.25247 14.0808C7.62755 14.4559 8.13625 14.6666 8.66669 14.6666L11.3334 8.66658V1.33325H3.81335C3.4918 1.32961 3.17977 1.44231 2.93475 1.65058C2.68973 1.85884 2.52824 2.14864 2.48002 2.46658L1.56002 8.46658C1.53102 8.65768 1.5439 8.85279 1.59779 9.03841C1.65168 9.22403 1.74529 9.39572 1.87211 9.54157C1.99894 9.68743 2.15597 9.80396 2.33231 9.8831C2.50864 9.96225 2.70008 10.0021 2.89335 9.99991H6.66669Z" stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_9405_1804">
                        <rect width="16" height="16" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg>
              }
              &nbsp;&nbsp;&nbsp;&nbsp; No
            </button>
          </div>
        }

        {!ok &&
          <div className={`mc-test-questions--details slow_ani  active ${isLoading ? 'loading' : ''}`}>
            <p>
              {
                yesOrNot === 'Si'
                  ? 'Cuéntanos más detalles'
                  : 'Cuéntanos más detalles'
              }
            </p>
            <textarea className={!yesOrNot ? 'disabled' : 'true'} disabled={yesOrNot ? false : true} onChange={handleChange} value={`${response ? response : ''}`} placeholder='Escribe aquí tus comentarios'></textarea>
            <span className='mc-test-questions--live'>{response ? response.length : 0} de 500 caractéres</span>
            <Button
              type="secondary"
              text="Enviar"
              loading={isLoading}
              status={yesOrNot === 'Si' ? 'active' : yesOrNot === 'No' ? 'active' : 'inactive'}
              onClick={handleQuiz}
            />
          </div>
        }

        {ok &&
          <>
            <p className='quizzok'>¡Gracias por la respuesta!</p>
          </>
        }
      </Container>
    </div>
  )
}

const mapState = ({ user: {token} }) => {
  return {
    token
  }
}

export default connect(mapState, {})(TestQuestions)